import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import CollectionsBookmarkOutlinedIcon from '@material-ui/icons/CollectionsBookmarkOutlined'
import BookOutlinedIcon from '@material-ui/icons/BookOutlined'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import useStyles from '../styles'
import { useFormContext } from 'react-hook-form'

const SingleOrLessonPack = ({ isLessonPacks, setIsLessonPacks }) => {
  const classes = useStyles({ isLessonPacks })
  const { register } = useFormContext()

  return (
    <Box className={classes.lessonTypeWrapper}>
      <Box
        className={classes.single}
        data-cy="single"
        onClick={() => setIsLessonPacks(false)}
      >
        <BookOutlinedIcon
          color="primary"
          fontSize="large"
          style={{ marginTop: '8px' }}
        />
        <Typography color="primary" variant="subtitle1" gutterBottom>
          Single Lesson
        </Typography>
        <Typography variant="body2">
          Individual lesson - Set your own price - Online payments optional
        </Typography>
        <CheckCircleIcon color="primary" className={classes.checkIcon} />
      </Box>
      <Box
        className={classes.lessonPacks}
        data-cy="lessonPack"
        onClick={() => setIsLessonPacks(true)}
      >
        <CollectionsBookmarkOutlinedIcon
          color="primary"
          fontSize="large"
          style={{ marginTop: '8px' }}
        />
        <Typography color="primary" variant="subtitle1" gutterBottom>
          Lesson Packs
        </Typography>
        <Typography variant="body2">
          Set your own quantities - Pay now book later - Online payments
          required
        </Typography>
        <CheckCircleIcon color="primary" className={classes.checkIcon} />
      </Box>
      <input
        name="isLessonPacks"
        type="hidden"
        ref={register()}
        value={isLessonPacks}
      />
    </Box>
  )
}

export default SingleOrLessonPack
